// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"z0-z","displaySixCardTiles":"A0-z"};